import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { ConsultDebt } from '../models/consult-debt.model';
import { GetConsultDebtOptions } from '../models/invoice.model';

import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class InvoiceService {
  constructor(
    protected _http: HttpClient,
    protected userService: UserService
  ) {}

  getAllFilters(args): Observable<any> {
    const url = `/listeners/ms/customer/contract/account/consult-debt/get-filters`;

    return this._http.post(url, args).pipe(
      map((response: any) => {
        if (response.Body.Success) {
          return response.Body.Result;
        }
      })
    );
  }

  /**
   * Get consult debts
   * @param consultDebt with information about the context of request
   */
  getConsultDebt(consultDebt: GetConsultDebtOptions): Observable<ConsultDebt[] | string> {
    const url = `/listeners/ms/customer/contract/account/consult-debt`;
    const args = { consultDebt };

    return this._http.post(url, args).pipe(
      map((response: any) => {
        const results = response.Body.Result as ConsultDebt[];

        if ((!results || results.length === 0) && response.Header) {
          return response.Header.Status.ResponseStatuses.ResponseStatus[0]?.Code;
        }

        return results;
      })
    );
  }

  /**
   * @param Decode false
   * @param ContentType "application/pdf"
   * @param DocData file in base64
   * @param args
   */
  getPdf(args: any): Observable<any> {
    const url = `/listeners/ms/storage/archive-record/get`;

    return this._http.post(url, args).pipe(
      // map((response: any) => {
      //   if (response.Body.Success) {
      //     return response.Body.Result;
      //   }
      //   throwError('Error occurred.');
      // }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  /**
   * @param process_identifier
   * @param args
   */
  getXml(args: any): Observable<any> {
    const url = `/listeners/ms/messaging/message/consumer/get-one/xml`;

    return this._http.post(url, args).pipe(
      // map((response: any) => {
      //   if (response.Body.Success) {
      //     return response.Body.Result;
      //   }
      //   throwError('Error occurred.');
      // }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }
}
